@import '../../../theme.less';

.index-info {
    padding: 0px;
    max-height: 688px;
    .info-row {
        width: @contentWidth;
        max-width: @contentMaxWidth;
        margin: 10vh auto 0 auto;
        // padding: 0px 5%;
        background: url('../../../assets/images/banner3_bg.png');
        background-size: cover;
        .ImagePanel {
            text-align: center;
            @media (max-width: 992px) {
                display: none;
            }
            img {
                max-width: 100%;
            }
        }
        .ImagePanel:nth-child(1) {
            margin-top: -50px;
        }
        .ImagePanel:nth-child(2) {
            margin-top: 50px;
        }
        .row {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .info-panel {
        font-size: 13px;
        line-height: 34px;
        letter-spacing: 0.5px;
        font-weight: 300;
        .title {
            font-size: 20px;
            font-weight: bold;
            color: #000;
        }
        p {
            color: #515151;
            font-size: 16px;
            line-height: 30px;
        }
    }
}
